import util from './util'

let ACFPosts = Vue.component('acf-posts', {
	props: ['posts', 'headline'],
	data() {
		return {
			permalinks: []
		}
	},
	mounted() {
		if (!this.posts) {
			return
		}
		for (let i = 0; i < this.posts.length; i++) {
			let id = this.posts[i].ID
			util.getPermalinkFromID(id).then((link) => {
				Vue.set(this.posts[i], 'permalink', JSON.parse(link))
			})
			util.getMultilineTitleFromID(id).then((title) => {
				Vue.set(this.posts[i], 'post_title', JSON.parse(title))
			})
		}
	},
	template: `
		<div class="group" v-if="posts">
			<span v-html="headline" class="post-list-label"></span>
			<transition-group name="fade" tag="ul" class="post-list">
				<li v-for="(post, index) in posts" :key="post.ID">
					<colored-link :type="post.post_type" :data-id="post.ID" :href="post.permalink" v-html="post.post_title"></colored-link>
				</li>
			</transition-group>
		</div>`
})

export default ACFPosts
